var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFound"},[_c('h2',[_vm._v("You got lost...")]),_vm._v(" "),_c('h3',[_vm._v("but you managed to find a wild carrot!")]),_vm._v(" "),_c('ObjectImage',{attrs:{"object":_vm.object,"scaleUpTo":"256"}}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("Object ID 404")]),_vm._v(" "),_c('router-link',{staticClass:"home",attrs:{"to":"/"}},[_vm._v("Go Back Home")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73410565","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 170
// module chunks = 0